type TProps = {
  media: [];
  className: string;
};

const GallerySkeleton: React.FC<TProps> = ({ className, media }) => {
  return (
    <div
      style={{
        gap: 12,
        display: "flex",
        flexWrap: "nowrap",
        overflow: "hidden",
      }}
      className="m-0 "
    >
      {media.map((_, i) => (
        <div
          key={i}
          className={`skeleton-rect ${className}`}
          style={{ flexShrink: 0 }}
        />
      ))}
    </div>
  );
};

export default GallerySkeleton;
